module.exports = __webpack_public_path__ + "img/运动小秘详情页_05.b9cc0d79.jpg";